
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 416 448","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M192 240v96c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V160C0 89.5 57.5 32 128 32h16c8.75 0 16 7.25 16 16v32c0 8.75-7.25 16-16 16h-16c-35.25 0-64 28.75-64 64v8c0 13.25 10.75 24 24 24h56c26.5 0 48 21.5 48 48zm224 0v96c0 26.5-21.5 48-48 48h-96c-26.5 0-48-21.5-48-48V160c0-70.5 57.5-128 128-128h16c8.75 0 16 7.25 16 16v32c0 8.75-7.25 16-16 16h-16c-35.25 0-64 28.75-64 64v8c0 13.25 10.75 24 24 24h56c26.5 0 48 21.5 48 48z"}})])
          )
        }
      }
    